import { connect } from 'react-redux';
import Deck from '../components/Deck.jsx';
import {
  getCurrentInvite,
  getEditFolderPermissions,
  getSlideIndex,
} from '../selectors';

const mapStateToProps = (state, props) => {
  const deck = state.decks.byId[props.id || (props.match && props.match.params.deckHash)] || {};

  return Object.assign({}, deck, {
    options: (state.folders.byId[deck.folder_id] || {}).options || {},
    canEditFolder: getEditFolderPermissions(state, props),
    invite: getCurrentInvite(state, props),
    slideIndex: getSlideIndex(state, props),
    slideReferrer: state.slides.slideReferrer,
  });
};

export default connect(mapStateToProps, null)(Deck);
